<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="300px"
  >
    <template v-slot:activator="{ on }">
      <v-badge
        right
        :color="disabled ? 'grey' : 'secondary'"
        class="bulk-badge"
      >
        <template v-slot:badge>
          <span>{{ param === 'brutto' ? 'BR' : 'NT' }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltipOn }">
            <v-btn
              icon
              small
              class="mt-1 mb-0 mx-2"
              :disabled="disabled"
              v-on="{ ...on, ...tooltipOn }"
            >
              <v-icon>
                calculate
              </v-icon>
            </v-btn>
          </template>
          <span>{{ title }}</span>
        </v-tooltip>
      </v-badge>
    </template>
    <v-card>
      <v-card-title>
        <span class="title">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <DecimalEditor
          v-model="weight"
          :scale="3"
          :label="title"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!weight"
          color="primary"
          flat
          @click="apply"
        >
          Рассчитать
        </v-btn>
        <v-btn
          flat
          @click="close"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["disabled", "param"],
  data: () => ({
    dialog: false,
    weight: 0,
  }),
  computed: {
    title() {
      return `Рассчет веса ${this.param === "brutto" ? "брутто" : "нетто"}`;
    },
  },
  methods: {
    apply() {
      this.$emit("change", this.weight);
      this.close();
    },
    close() {
      this.weight = 0;
      this.dialog = false;
    },
  },
};
</script>
